import React from 'react';
import classes from "../home/css/Head.module.css";
import logo from "../../images/logo.png";
import { Link, useLocation } from "react-router-dom";

const Head = () => {
  const location = useLocation();

  return (
    <div className={classes.head}>
      <Link to="/home">
        <img src={logo} alt="Logo" className={classes.logo} />
      </Link>
      {location.pathname === '/' ? null :
        <span className={classes.description}>
          the most exclusive luxury brand in the world, with a philanthropic
          mission
        </span>}
    </div>
  )
}

export default Head;

